<script setup>
defineProps({
  logo: {
    type: Object,
    default: () => {},
  },
});
</script>

<template>
  <div v-if="logo" class="footer__top">
    <Logo
      :src="logo?.src"
      :alt="logo?.alt"
      :height="logo?.height"
      :width="logo?.width"
    />
  </div>
</template>
<style scoped lang="scss">
.footer {
  &__top {
    display: flex;
    justify-content: center;
    &:deep(.logo__image) {
      height: auto;
      @include media-breakpoint-up(sm) {
        width: 94px;
      }
      @include media-breakpoint-up(md) {
        width: 96px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(width, 96);
      }
    }
  }
}
</style>
